import { render, staticRenderFns } from "./GamanzaRewardShop.vue?vue&type=template&id=3d56031b&scoped=true"
import script from "./GamanzaRewardShop.vue?vue&type=script&lang=js"
export * from "./GamanzaRewardShop.vue?vue&type=script&lang=js"
import style0 from "./GamanzaRewardShop.vue?vue&type=style&index=0&id=3d56031b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d56031b",
  null
  
)

export default component.exports